import React from 'react'
import { withTranslation } from "react-i18next";
import images from 'ressources/images';

const Success = ({t}) => {
  return (
    <div className='max-w'>
        <img src={images.checkmark} alt="" width="100" height="100" />
        <p className="text mt">{t('ssoretailer_create_account_welcome')}</p>
        <br />
        <p className='text'>{t('ssoretailer_create_account_redirect')}</p>
    </div>
  )
}

export default withTranslation()(Success)
